"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.type15Fields = void 0;
exports.type15Fields = {
    LogicalRecordLengthT15: {
        label: 'Logical Record Length',
        minLength: 3,
        maxLength: 7,
        required: false,
        desc: 'This mandatory ASCII field shall contain the total count of the number of bytes in the Type-15  logical record. Field 15.001 shall specify the length of the record including every character of  every field contained in the record and the information separators.',
        EBTS: {
            mnemonic: 'T15_LEN',
            index: '15.001',
            dataType: 'N'
        }
    },
    ImageDesignationCharacterT15: {
        label: 'Image Designation Character',
        minLength: 1,
        maxLength: 4,
        required: false,
        desc: 'This mandatory ASCII field shall be used to identify the palmprint image data contained in the  record. This IDC shall match the IDC found in the file content (CNT) field of the Type-1 record.',
        EBTS: {
            mnemonic: 'T15_IDC',
            index: '15.002',
            dataType: 'N'
        }
    },
    ImpressionTypeT15: {
        label: 'Impression Type',
        minLength: 1,
        maxLength: 2,
        required: false,
        options: [
            ['10', 'Live-scan palm'],
            ['11', 'Nonlive-scan palm'],
            ['12', 'Latent palm impression'],
            ['13', 'Latent palm tracing'],
            ['14', 'Latent palm photo'],
            ['15', 'Latent palm lift'],
            ['28', 'Other'],
            ['29', 'Unknown']
        ],
        desc: 'This mandatory one- or two-byte ASCII field shall indicate the manner by which the palmprint  image information was obtained. The appropriate code choice selected from Table 11 for palm  shall be entered in this field.',
        EBTS: {
            mnemonic: 'T15_IMP',
            index: '15.003',
            dataType: 'N'
        }
    },
    SourceAgencyORIT15: {
        label: 'Source Agency / ORI',
        minLength: 9,
        maxLength: 35,
        required: false,
        desc: 'This mandatory ASCII field shall contain the identification of the administration or organization  that originally captured the palmprint image contained in the record. Normally, the ORI of the  agency that captured the image will be contained in this field. The SRC may contain up to 36  identifying characters and the data content of this field shall be defined by the user and be in  accordance with the receiving agency.',
        EBTS: {
            mnemonic: 'T15_SRC',
            index: '15.004',
            dataType: 'AN'
        }
    },
    PalmprintCaptureDate: {
        label: 'Palmprint Capture Date',
        type: 'date',
        maxLength: undefined,
        required: false,
        desc: 'This mandatory ASCII field shall contain the date that the palmprint image contained in the record  was captured. The date shall appear as eight digits in the format YYYYMMDD. The YYYY  characters shall represent the year the image was captured; the MM characters shall be the tens  and units values of the month; and the DD characters shall be the tens and units values of the  day in the month. For example, 20040229 represents February 29, 2004. The complete date  must be a legitimate date.',
        EBTS: {
            mnemonic: 'T15_PCD',
            index: '15.005',
            dataType: 'N',
            format: 'YYYYMMDD'
        }
    },
    HorizontalLineLengthT15: {
        label: 'Horizontal Line Length',
        minLength: 3,
        maxLength: 4,
        required: false,
        desc: 'This mandatory ASCII field shall contain the number of pixels contained on a single horizontal line  of the transmitted image.',
        EBTS: {
            mnemonic: 'T15_HLL',
            index: '15.006',
            dataType: 'N'
        }
    },
    VerticalLineLengthT15: {
        label: 'Vertical Line Length',
        minLength: 3,
        maxLength: 4,
        required: false,
        desc: 'This mandatory ASCII field shall contain the number of horizontal lines contained in the  transmitted image.',
        EBTS: {
            mnemonic: 'T15_VLL',
            index: '15.007',
            dataType: 'N'
        }
    },
    ScaleUnitsT15: {
        label: 'Scale Units',
        minLength: 1,
        maxLength: 1,
        required: false,
        options: [
            ['0', 'No Scale Given'],
            ['1', 'Pixels per Inch'],
            ['2', 'Pixels per Centimeter']
        ],
        desc: "This mandatory ASCII field shall specify the units used to describe the image sampling frequency  (pixel density). A '1' in this field indicates pixels per inch, or a '2' indicates pixels per centimeter.  A '0' in this field indicates no scale is given. For this case, the quotient of HPS/VPS gives the  pixel aspect ratio.",
        EBTS: {
            mnemonic: 'T15_SLC',
            index: '15.008',
            dataType: 'N'
        }
    },
    HorizontalPixelScaleT15: {
        label: 'Horizontal Pixel Scale',
        minLength: 1,
        maxLength: 4,
        required: false,
        desc: "This mandatory ASCII field shall specify the integer pixel density used in the horizontal direction  of the transmitted image providing the SLC contains a '1' or a '2'. Otherwise, it indicates the  horizontal component of the pixel aspect ratio.",
        EBTS: {
            mnemonic: 'T15_HPS',
            index: '15.009',
            dataType: 'N'
        }
    },
    VerticalPixelScaleT15: {
        label: 'Vertical Pixel Scale',
        minLength: 1,
        maxLength: 4,
        required: false,
        desc: "This mandatory ASCII field shall specify the integer pixel density used in the vertical direction of  the transmitted image providing the SLC contains a '1' or a '2'. Otherwise, it indicates the  vertical component of the pixel aspect ratio.",
        EBTS: {
            mnemonic: 'T15_VPS',
            index: '15.010',
            dataType: 'N'
        }
    },
    CompressionAlgorithmT15: {
        label: 'Compression Algorithm',
        minLength: 3,
        maxLength: 5,
        required: false,
        options: [
            ['NONE', 'None'],
            ['WSQ', 'Wavelet Scalar Quantization (WSQ)'],
            ['WSQ20', 'Wavelet Scalar Quantization (WSQ) FBI Revision 2.0'],
            ['JPEGB', 'Baseline Compression'],
            ['JPEGL', 'Lossless Compression'],
            ['JP2', 'JPEG 2000 ISO/IEC 15444-1 (Lossy)'],
            ['JP2L', 'JPEG 2000 ISO/IEC 15444-1 (Lossless)'],
            ['PNG', 'Portable Network Graphics']
        ],
        desc: "This mandatory ASCII field shall specify the algorithm used to compress the transmitted  grayscale images. An entry of 'NONE' in this field indicates that the data contained in this record  is uncompressed. For those images that are to be compressed, this field shall contain the code  from Table 1 to indicate the compression method used for this record type. The preferred  methods for the compression of palmprint images are WSQ for those images scanned or  transmitted at 500 ppi or JPEG 2000 for those images scanned and transmitted at 1000 ppi. See  Section 5.6.1. and the Profile for 1000 ppi Fingerprint Compression for additional information on  the usage of JPEG 2000 for the compression of fingerprint images. The domain registrar  maintains a registry of acceptable compression techniques and corresponding codes that may be  used as they become available.",
        EBTS: {
            mnemonic: 'T15_CGA',
            index: '15.011',
            dataType: 'AN'
        }
    },
    BitsPerPixelT15: {
        label: 'Bits per pixel',
        minLength: 1,
        maxLength: 2,
        required: false,
        desc: "This mandatory ASCII field shall contain the number of bits used to represent a pixel. This field  shall contain an entry of '8' for normal grayscale values of '0' to '255'. Any entry in this field  greater than '8' shall represent a grayscale pixel with increased precision.",
        EBTS: {
            mnemonic: 'T15_BPX',
            index: '15.012',
            dataType: 'N'
        }
    },
    PalmprintPosition: {
        label: 'Palmprint Position',
        minLength: 2,
        maxLength: 2,
        required: false,
        options: [
            ['20', 'Unknown Palm'],
            ['21', 'Right Full Palm'],
            ['22', 'Right Writer’s Palm'],
            ['23', 'Left Full Palm'],
            ['24', 'Left Writer’s Palm'],
            ['25', 'Right Lower Palm'],
            ['26', 'Right Upper Palm'],
            ['27', 'Left Lower Palm'],
            ['28', 'Left Upper Palm'],
            ['29', 'Right Other'],
            ['30', 'Left Other'],
            ['31', 'Right Interdigital'],
            ['32', 'Right Thenar'],
            ['33', 'Right Hypothenar'],
            ['34', 'Left Interdigital'],
            ['35', 'Left Thenar'],
            ['36', 'Left Hypothenar']
        ],
        desc: 'This mandatory tagged field shall contain the palmprint position that matches the palmprint  image. The decimal code number corresponding to the known or most probable palmprint  position shall be taken from Table 35 and entered as a two-character ASCII subfield.',
        EBTS: {
            mnemonic: 'T15_PLP',
            index: '15.013',
            dataType: 'N'
        }
    },
    ScanHorizontalPixelScaleT15: {
        label: 'Scan Horizontal Pixel Scale',
        minLength: 1,
        maxLength: 4,
        desc: "This optional ASCII field shall specify the horizontal pixel density used for the scanning of the  original impression providing the SLC field contains a '1' or a '2'. Otherwise, it indicates the  horizontal component of the pixel aspect ratio.",
        EBTS: {
            mnemonic: 'T15_SHPS',
            index: '15.016',
            dataType: 'N'
        },
        required: false
    },
    ScanVerticalPixelScaleT15: {
        label: 'Scan Vertical Pixel Scale',
        minLength: 1,
        maxLength: 4,
        desc: "This optional ASCII field shall specify the vertical pixel density used for the scanning of the  original impression providing the SLC field contains a '1' or a '2'. Otherwise, it indicates the  vertical component of the pixel aspect ratio.",
        EBTS: {
            mnemonic: 'T15_SVPS',
            index: '15.017',
            dataType: 'N'
        },
        required: false
    },
    CommentT15: {
        label: 'Comment',
        minLength: 1,
        maxLength: 127,
        desc: 'This optional field may be used to insert comments or other ASCII text information with the  palmprint image data.',
        EBTS: {
            mnemonic: 'T15_COM',
            index: '15.020',
            dataType: 'ANS',
            specialChars: 'PRINT'
        },
        required: false
    },
    PalmprintQualityMetric: {
        label: 'Palmprint Quality Metric',
        type: 'header',
        minLength: 7,
        maxLength: 14,
        maxOccurrences: 4,
        desc: "This optional ASCII field is used to specify one or more different metrics of palm image quality  score data for the image stored in this record. The meaning attributed to this metric must be  defined and interpreted by the producer of the scoring algorithm or by the person or system used  to assign the metric to the palm print image. The metric may be a predictor of AFIS matcher  accuracy performance or a different metric to indicate a value associated with the quality of the  palm print image for a particular function.. This field may contain one or more subfields, each consisting of four information items. The first  information item is the palm code as chosen from Table 35.  The other three items identify a quality score and the algorithm used to create the quality score.  This information is useful to enable the recipient of the quality score to differentiate between  quality scores generated by different algorithms and adjust for any differences in processing or  analysis as necessary.  The second information item shall be a quantitative expression of the predicted matching  performance of the biometric sample. This item contains the ASCII representation of the  integer image quality score between 0 and 100 assigned to the image data by a quality  algorithm. Higher values indicate better quality. An entry of '255' shall indicate a failed  attempt to calculate a quality score. An entry of '254' shall indicate that no attempt to  calculate a quality score was made. The use of additional values to convey other  information should be harmonized with ISO/IEC 19794 standards.  The third information item shall specify the ID of the vendor of the quality algorithm used  to calculate the quality score. This 4-digit hex value is assigned by IBIA and expressed  as four ASCII characters. The IBIA shall maintain the Vendor Registry of CBEFF  Biometric Organizations that will map the value in this field to a registered organization.  The fourth information item shall specify a numeric product code assigned by the vendor  of the quality algorithm, which may be registered with the IBIA, but registration is not  required. It indicates which of the vendor’s algorithms was used in the calculation of the  quality score. This field contains the ASCII representation of the integer product code and  should be within the range 1 to 65535.",
        EBTS: {
            mnemonic: 'T15_PQM',
            index: '15.024:',
            dataType: 'N'
        },
        subFields: {
            fields: {
                PalmprintCode: {
                    label: 'Palmprint Code',
                    minLength: 1,
                    maxLength: 2,
                    required: false,
                    options: [
                        ['20', 'Unknown Palm'],
                        ['21', 'Right Full Palm'],
                        ['22', 'Right Writer’s Palm'],
                        ['23', 'Left Full Palm'],
                        ['24', 'Left Writer’s Palm'],
                        ['25', 'Right Lower Palm'],
                        ['26', 'Right Upper Palm'],
                        ['27', 'Left Lower Palm'],
                        ['28', 'Left Upper Palm'],
                        ['29', 'Right Other'],
                        ['30', 'Left Other'],
                        ['31', 'Right Interdigital'],
                        ['32', 'Right Thenar'],
                        ['33', 'Right Hypothenar'],
                        ['34', 'Left Interdigital'],
                        ['35', 'Left Thenar'],
                        ['36', 'Left Hypothenar']
                    ],
                    EBTS: {
                        mnemonic: 'T15_PQM_PPC',
                        index: '15.024..1',
                        dataType: 'N'
                    }
                },
                PalmprintQualityScore: {
                    label: 'Palmprint Quality Score',
                    minLength: 1,
                    maxLength: 3,
                    required: false,
                    EBTS: {
                        mnemonic: 'T15_PQM_SCR',
                        index: '15.024..2',
                        dataType: 'N'
                    }
                },
                PalmprintQualityVendor: {
                    label: 'Palmprint Quality Vendor',
                    minLength: 4,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T15_PQM_VEN',
                        index: '15.024..3',
                        dataType: 'AN'
                    }
                },
                PalmprintQualityProductCode: {
                    label: 'Palmprint Quality Product Code',
                    minLength: 1,
                    maxLength: 5,
                    required: false,
                    EBTS: {
                        mnemonic: 'T15_PQM_VEN',
                        index: '15.024..4',
                        dataType: 'N'
                    }
                }
            }
        },
        required: false
    },
    DeviceMonitoringModeT15: {
        label: 'Device Monitoring Mode',
        minLength: 7,
        maxLength: 10,
        options: [
            ['CONTROLLED', 'Operator physically controls the subject to acquire biometric sample'],
            ['ASSISTED', 'Person available to provide assistance to subject submitting the biometric'],
            ['OBSERVED', 'Person present to observe operation of the device but provides no assistance'],
            ['UNATTENDED', 'No one present to observe or provide assistance'],
            ['UNKNOWN', 'No information is known']
        ],
        desc: 'This optional field provides information describing the level of human monitoring for the image  capture device. This field will contain an entry from Table 27 to indicate the monitoring mode of  the biometric sample capture device.',
        EBTS: {
            mnemonic: 'T15_DMM',
            index: '15.030',
            dataType: 'A'
        },
        required: false
    },
    ImageDataT15: {
        label: 'Image data',
        minLength: 1,
        required: false,
        EBTS: {
            mnemonic: 'T15_DAT',
            index: '15.999',
            dataType: 'B1'
        }
    }
};
//# sourceMappingURL=jfd.type15.js.map